@if (visible()) {
  <div
    class="nutrix-call-widget"
    cdkDrag
    cdkDragBoundary="body"
    role="dialog"
    aria-label="Llamada de WhatsApp en curso"
  >
    <div class="nutrix-call-widget__handle" cdkDragHandle>
      <i class="pi pi-whatsapp"></i>
      <div class="nutrix-call-widget__meta">
        <span class="nutrix-call-widget__name">{{ call.active()?.name || 'Paciente' }}</span>
        <span class="nutrix-call-widget__status">
          @if (call.recording()) {
            <i class="pi pi-circle-fill nutrix-call-widget__rec"></i>
          }
          {{ statusLabel() }}
        </span>
      </div>
      <i class="pi pi-arrows-alt nutrix-call-widget__drag" aria-hidden="true"></i>
    </div>

    <div class="nutrix-call-widget__controls">
      <p-button
        [rounded]="true"
        [text]="true"
        size="large"
        [severity]="call.muted() ? 'warn' : 'secondary'"
        [icon]="call.muted() ? 'pi pi-microphone-slash' : 'pi pi-microphone'"
        [pTooltip]="call.muted() ? 'Activar micrófono' : 'Silenciar'"
        tooltipPosition="top"
        [disabled]="call.phase() !== 'active'"
        (click)="toggleMute()"
        aria-label="Silenciar micrófono"
      />

      <p-button
        [rounded]="true"
        size="large"
        severity="danger"
        icon="pi pi-phone"
        pTooltip="Colgar"
        tooltipPosition="top"
        (click)="hangup()"
        aria-label="Colgar llamada"
      />
    </div>

    @if (call.lastError(); as err) {
      <div class="nutrix-call-widget__error">{{ err }}</div>
    }
  </div>
}
